export const getIcon = (icon) => require(`static/icons/svg/${icon}.svg`)
export const getIcons = (icon) => require(`static/icons/svg/${icon}.svg.icon`)
export const getJpgImages = (icon) => require(`static/images/${icon}.jpg`)
export const getPngImages = (icon) => require(`static/images/${icon}.png`)
